import connection from './connection.js'

const list = async function (page, keyword, categoryId, callback) {
  const url = '/admin/goods/list'
  let {
    error,
    data
  } = await connection.query(url, {
    page: page,
    keyword: keyword,
    categoryId: categoryId
  })
  if (callback) callback(error, data)
}

const create = async function (params, callback) {
  const url = '/admin/goods/create'
  let {
    error,
    data
  } = await connection.update(url, params)
  if (callback) callback(error, data)
}

const update = async function (id, updateData, callback) {
  const url = '/admin/goods/update'
  let {
    error,
    data
  } = await connection.update(url, {
    id: id,
    updateData: updateData
  })
  if (callback) callback(error, data)
}

const updateStatus = async function (id, status, callback) {
  const url = '/admin/goods/update/status'
  let {
    error,
    data
  } = await connection.update(url, {
    id: id,
    status: status
  })
  if (callback) callback(error, data)
}

const editSpec = async function (specId, spec, callback) {
  const url = '/admin/goods/update/spec'
  let {
    error,
    data
  } = await connection.update(url, {
    specId: specId,
    spec: spec
  })
  if (callback) callback(error, data)
}

const delSpec = async function (specId, callback) {
  const url = '/admin/goods/del/spec'
  let {
    error,
    data
  } = await connection.update(url, {
    specId: specId,
  })
  if (callback) callback(error, data)
}

const addSpecItem = async function (goodsId, specId, specItemValue, callback) {
  const url = '/admin/goods/add/spec/item'
  let {
    error,
    data
  } = await connection.update(url, {
    goodsId: goodsId,
    specId: specId,
    specItemValue: specItemValue
  })
  if (callback) callback(error, data)
}

const delSpecItem = async function (specId, callback) {
  const url = '/admin/goods/del/spec/item'
  let {
    error,
    data
  } = await connection.update(url, {
    specId: specId
  })
  if (callback) callback(error, data)
}

const delImage = async function (imageId, type, callback) {
  const url = '/admin/goods/del/image'
  let {
    error,
    data
  } = await connection.update(url, {
    id: imageId,
    type: type
  })
  if (callback) callback(error, data)
}

const delItem = async function (id, callback) {
  const url = '/admin/goods/del'
  let {
    error,
    data
  } = await connection.update(url, {
    id: id,
  })
  if (callback) callback(error, data)
}

const goodsConf = async function (id, updateData, callback) {

  const url = '/admin/goods/import/update/' + id
  let {
    error,
    data
  } = await connection.update(url, updateData)
  if (callback) callback(error, data)
}

const goodsConfDetail = async function (id,callback) {
  const url = '/admin/goods/import/detail/' + id
  let {
    error,
    data
  } = await connection.query(url)
  if (callback) callback(error, data)
}

export default {
  list: list,
  create: create,
  updateStatus: updateStatus,
  update: update,
  editSpec: editSpec,
  delSpec: delSpec,
  addSpecItem: addSpecItem,
  delSpecItem: delSpecItem,
  delImage: delImage,
  delItem: delItem,
  goodsConf: goodsConf,
  goodsConfDetail: goodsConfDetail
}
